import {
    getFirestore,
    collection,
    query,
    where,
    getDocs,
    doc,
    setDoc,
    writeBatch,
} from "firebase/firestore";
import { firebaseApp } from "./firebase"; // Assuming you have already initialized Firebase
import React from "react";

// const db = getFirestore(firebaseApp);

// async function transferDocuments() {
//     // Step 1: Create a reference to the 'units_lindisc' collection
//     const lindiscCollection = collection(db, "units_lindisc");

//     // Step 2: Build the query to get documents where 'order' >= 3
//     const q = query(lindiscCollection, where("order", ">=", 3));

//     // Step 3: Get documents matching the query
//     const querySnapshot = await getDocs(q);

//     // Step 4: Prepare the batch operation
//     const batch = writeBatch(db);

//     // Step 5: Loop through the documents and add them to the batch for writing to the 'units_calc' collection
//     querySnapshot.forEach((docSnapshot) => {
//         const docData = docSnapshot.data();
//         const newDocRef = doc(db, "units_calc", docSnapshot.id); // Use the same document ID for consistency

//         // Step 6: Add the document to the batch for the new collection
//         batch.set(newDocRef, docData);
//     });

//     // Step 7: Commit the batch operation to apply the changes
//     await batch.commit();

//     console.log("Documents transferred successfully!");
// }

const bruh = () => {
    alert("bruh");
}

export default function SecretPage() {

    return <>
        <div style={{
            padding: "20px"
        }}>
            <h1>Secret Page</h1>
            <p>This page is a secret.</p>
            
            <br></br>

            <button onClick={bruh}>Super Secret Functionality</button>
        </div>
    </>
}
